import { ToothbrushIcon } from './ToothbrushIcon';

/**
 * author: Michael Irigoyen
 * id 1BA32EF0-94A2-4F7E-BD93-5A9102143F8E
 * name toothbrush
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toothbrush.svg
 * tags
 * - Medical / Hospital 
 */
export const OralHygieneIcon = ToothbrushIcon;
export default OralHygieneIcon